// @ts-nocheck
import { addToChainAfter, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionRealTimePriceApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = GetProductCollectionRealTimePriceApiV2Parameter &
    HasOnSuccess<RealTimePricingModel> &
    HasOnError<unknown>;

interface Props {
    apiResult: RealTimePricingModel;
    apiParameter: GetProductCollectionRealTimePriceApiV2Parameter;
    error?: unknown;
}

type HandlerType = Handler<Parameter, Props>;
export const filterVariantParent: HandlerType = props => {
    const { apiParameter } = props;
    const state = props.getState();
    const filteredProducts = apiParameter.productPriceParameters.filter(param => {
        const product = getProductState(state, param.productId);
        return !product?.value?.isVariantParent === true;
    });
    if (filteredProducts?.length === 0) {
        return false;
    }
    apiParameter.productPriceParameters = filteredProducts;
};

addToChainAfter(chain, PopulateApiParameter, filterVariantParent);
